module.exports = __webpack_public_path__ + "img/36_53.1294be1a.png";